<template>
	<tr class="tableTr">
		<td>
			<field
					margin="0"
					padding="0"
					height="24"
					:switch-value="isCheck"
					@updateSwitch="onCheckbox"
					is-dense
					is-checkbox
					is-off-style
			></field>
		</td>
		<td>{{ item.customer }}</td>
		<td :class="{'errorField': valid.dispatchCustomers && valid.dispatchCustomers.$each.$iter[idx].$error}">
			<field
					width="100%"
					margin="0"
					placeholder="Enter email"
					@updateInput="onInput"
					:setInputValue="item.email"
					is-off-style
			></field>
		</td>
		<td style="color: #19BC38;text-align: center;">
			<button type="button" @click="onPreview(item.file)">
				<svg-sprite height="20" width="20" icon-id="eye"></svg-sprite>
			</button>
		</td>
	</tr>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "TableTr",
	props: {
		item: Object,
		valid: Object,
		checkAll: Boolean,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	watch: {
		checkAll(val) {
			this.isCheck = val;
			this.item.isCheck = val;
		}
	},
	data: () => ({
		isCheck: false
	}),
	methods: {
		...mapActions([ 'onPreview' ]),
		onCheckbox({ value }) {
			this.isCheck = value;
			this.item.isCheck = value;
			this.$emit('updateCheckOrder', this.item);
		},
		onInput({ value }) {
			this.item.email = value;
		}
	},
	mounted() {
		this.isCheck = this.item.isCheck;
	}
};
</script>

<style lang="scss" scoped>
@import "TableTr";
</style>

<style lang="scss">
@import "TableTr-global";
</style>
